import { FC, useEffect, useState } from 'react';
import { SelectOption } from '@/components/_inputs';
import { useModal } from '@/hooks';
import { getIconByNetwork } from '@/helpers';
import { AmlFlowEnum } from '@/api';
import { AppImage, CompareReportsModal, Skeleton } from '@/components';
import styles from './ChainSelector.module.sass';

interface ChainSelectorProps {
  list: SelectOption[];
  isDisabled?: boolean;
  onSelect: (selection: string) => void;
  limited?: boolean;
  modeChains?: string[];
  flow?: string;
}

const ChainSelector: FC<ChainSelectorProps> = (props) => {
  const {
    list,
    isDisabled,
    onSelect,
    limited = false,
    modeChains = [],
    flow = '',
  } = props;
  const [active, setActive] = useState<string | null>();

  useEffect(() => {
    setActive(null);
  }, [list]);

  const {
    isOpen: isOpenCompareReportsModal,
    onOpenModal: handleOpenCompareReportsModal,
    onCloseModal: handleCloseCompareReportsModal,
  } = useModal();

  const handleClick = (option: SelectOption) => {
    if (isDisabled) {
      return;
    }

    if (option.isLimited) {
      handleOpenCompareReportsModal();
    } else {
      setActive(option.value);
      onSelect(option.value);
    }
  };

  return (
    <>
      <div className={styles.list}>
        {list.map((option: SelectOption) => (
          <button
            type="button"
            className={`${styles.item}
            ${
              option.isLimited &&
              flow === AmlFlowEnum.INSTANT &&
              styles['item--disabled']
            }
            ${option.isDisabled && styles['item--disabled']}
            ${active === option.value && styles['item--active']}`}
            key={option.value}
            onClick={() => handleClick(option)}
          >
            <AppImage
              className={styles.icon}
              src={getIconByNetwork(option.value)}
              alt={option.value}
              fallback={<Skeleton className={styles.icon} border="50%" />}
            />
            <div className={styles.label}>{option.label}</div>
            {limited && !modeChains.includes(option.value) && (
              <div className={styles.limited}>pro</div>
            )}
          </button>
        ))}
      </div>
      <CompareReportsModal
        isOpen={isOpenCompareReportsModal}
        onClose={handleCloseCompareReportsModal}
      />
    </>
  );
};

export default ChainSelector;
